import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./EventCenterInfoCard.module.css";
import classNames from "classnames";
import { v4 } from "uuid";

import Card from "shared/Card";
import InfoItem from "Security/Shared/InfoItem";

/**
 * Interactive component. Displays event center information inside of a card.
 * Updates to autofilled input boxes when edit is clicked.
 */
export function EventCenterInfoCard({ centerInfo, onSave }) {
  const [isEdit, setIsEdit] = useState(false);
  const [tempCenterInfo, setTempCenterInfo] = useState(centerInfo);

  const eventPieces = [
    {
      label: "Address Line 1",
      description: "address1",
    },
    {
      label: "Address Line 2",
      description: "address2",
    },
    {
      label: "Phone Number",
      description: "phoneNumber",
    },
    { label: "Email", description: "email" },
    {
      label: "Emergency Contact",
      description: "emergencyContact",
    },
  ];

  return (
    <Card
      className={styles.card}
      children={
        <div className={styles.container}>
          <div className={styles.header}>
            <p>Event Center Information</p>
            <div className={styles.grid}>
              <button
                className={classNames(styles.transition, styles["button"], {
                  [styles.hidden]: isEdit,
                })}
                onClick={() => setIsEdit(true)}
              >
                Edit
              </button>
              <button
                className={classNames(styles.transition, styles["button"], {
                  [styles.hidden]: !isEdit,
                })}
                onClick={() => {
                  setIsEdit(false);
                  onSave(tempCenterInfo);
                }}
              >
                Save
              </button>
            </div>
          </div>
          <div className={styles.grid}>
            <div
              id="normal"
              className={classNames(styles.transition, styles.event, {
                [styles.hidden]: isEdit,
              })}
            >
              {eventPieces.map((property) => (
                <InfoItem
                  key={v4()}
                  label={property.label}
                  description={tempCenterInfo[property.description]}
                />
              ))}
            </div>
            <div
              id="input"
              className={classNames(styles.transition, styles.event, {
                [styles.hidden]: !isEdit,
              })}
            >
              {eventPieces.map((property) => (
                <div key={v4()}>
                  <div className={styles["object-label"]}>{property.label}</div>
                  <div className={styles["object-description-input"]}>
                    <input
                      type="text"
                      placeholder="Add text here..."
                      value={tempCenterInfo[property.description]}
                      onChange={(key) => {
                        setTempCenterInfo({
                          ...tempCenterInfo,
                          [property.description]: key.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      }
    />
  );
}

EventCenterInfoCard.propTypes = {
  /**
   * Object with the event center details.
   */
  centerInfo: PropTypes.shape({
    address1: PropTypes.string,
    address2: PropTypes.string,
    phoneNumber: PropTypes.string,
    email: PropTypes.string,
    emergencyContact: PropTypes.string,
  }),
  /**
   * Function called when the save button is clicked.
   */
  onSave: PropTypes.func,
};

EventCenterInfoCard.defaultProps = {
  centerInfo: {
    address1: "",
    address2: "",
    phoneNumber: "",
    email: "",
    emergencyContact: "",
  },
};
